import React, { Fragment } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { BookingSettings, InventoryStatus } from '../../../../core/api/models';
import ErrorMessage from '../../../../components/text/ErrorMessage';
import { DropdownList, Multiselect } from 'react-widgets';
import { convertPascalCaseToWords } from '../../../../core';

const UpdateForm: React.FunctionComponent<{
  onSubmit: (data: BookingSettings) => void;
  onCancel: () => void;
  isSubmitting?: boolean;
  data?: BookingSettings;
  error?: string;
}> = (props) => {
  const { control, handleSubmit, errors } = useForm<BookingSettings>({
    reValidateMode: 'onChange',
    mode: 'onSubmit',
  });

  const renderBookingExpiry = () => {
    return (
      <div className="col-12">
        <label className="font-sm text-uppercase">Booking Expiry</label>
        <div className="row">
          <div className="col-6">
            <div className="form-group font-weight-semibold mb-3">
              <Controller
                control={control}
                rules={{
                  required: 'Booking Expiry is required',
                  validate: {
                    numberOnly: (value) =>
                      new RegExp('\\d+').test(value) || 'Invalid value',
                    min: (value) =>
                      Number(value) >= 0 || 'Value shoud be positive',
                  },
                }}
                name="expiry.value"
                defaultValue={props.data?.expiry?.value}
                render={({ onChange, value, name }) => (
                  <input
                    type="number"
                    min={0}
                    className="form-control rounded-sm font-weight-semibold"
                    placeholder="Booking Expiry"
                    name={name}
                    value={value}
                    onChange={onChange}
                    id="expiry.value"
                  />
                )}
              />
              <ErrorMessage>{errors.expiry?.value?.message}</ErrorMessage>
            </div>
          </div>
          <div className="col-6">
            <div className="form-group font-weight-semibold mb-3">
              <Controller
                control={control}
                name="expiry.unit"
                defaultValue={props.data?.expiry?.unit || 'Hours'}
                render={({ onChange, value, name }) => (
                  <DropdownList
                    data={[
                      {
                        label: 'Minutes',
                        value: 'Minutes',
                      },
                      {
                        label: 'Hours',
                        value: 'Hours',
                      },
                      {
                        label: 'Days',
                        value: 'Days',
                      },
                    ]}
                    id="expiry.unit"
                    placeholder="Unit"
                    name={name}
                    defaultValue={'Hours'}
                    value={value}
                    onChange={(val) => onChange(val.value)}
                    textField="label"
                    valueField="value"
                  />
                )}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderVehicleStatus = () => {
    return (
      <div className="col-12">
        <label className="font-sm text-uppercase">
          Vehicle status to be avoid on vin expiry
        </label>
        <div className="">
          <div className="form-group font-weight-semibold mb-3">
            <Controller
              control={control}
              name="vehicleStatus"
              defaultValue={props.data?.vehicleStatus}
              render={({ onChange, value, name }) => (
                <Fragment>
                  <Multiselect
                    value={value}
                    data={Object.keys(InventoryStatus).map((key) => {
                      return {
                        label: convertPascalCaseToWords(key),
                        value: key,
                      };
                    })}
                    defaultValue={value}
                    textField={'label'}
                    valueField={'value'}
                    placeholder={'Select Vehicle status'}
                    onChange={(val) => {
                      onChange(val?.map((x) => x.value));
                    }}
                    allowCreate="onFilter"
                    autoFocus={true}
                  />
                </Fragment>
              )}
            />
          </div>
        </div>
      </div>
    );
  };

  const renderButton = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3 text-right pt-3">
          <button
            type="button"
            className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
            onClick={props.onCancel}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary py-2 font-weight-semibold font-normal px-4 "
            disabled={props.isSubmitting}
          >
            Update
          </button>
        </div>
      </div>
    );
  };

  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <div className="p-4">
        <h4 className="mb-3 font-weight-semibold">Update Booking Settings</h4>
        <div className="row gutter-10">
          {renderBookingExpiry()}
          {renderVehicleStatus()}
          <ErrorMessage>{props.error}</ErrorMessage>
          {renderButton()}
        </div>
      </div>
    </form>
  );
};

export default UpdateForm;
